function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M202.081 249.108C291.355 249.108 363.726 246.618 363.726 243.546C363.726 240.474 291.355 237.984 202.081 237.984C112.807 237.984 40.4355 240.474 40.4355 243.546C40.4355 246.618 112.807 249.108 202.081 249.108Z",
  fill: "#E3E5FC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M346.626 59.5166C336.062 58.5748 326.117 55.865 316.892 50.9299C311.485 48.0389 305.305 44.2863 300.444 40.7417C290.381 33.4087 280.601 26.8781 270.945 19.1321C270.845 19.0519 269.499 18.1071 269.539 18.0001C269.539 18.0001 267.648 22.7303 267.648 22.7332C277.015 29.8968 285.994 37.4496 295.505 44.4675C308.892 54.3408 325.077 63.8189 343.107 65.0668C346.75 65.3194 346.626 59.5166 346.626 59.5166Z",
  fill: "#D4A79A"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M348.614 46.8561L348.752 60.3691L360.494 64.9091C360.494 64.9091 353.778 55.3418 355.414 47.1235C357.049 38.9052 348.614 46.8561 348.614 46.8561Z",
  fill: "#D4A79A"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M339.333 18.8492C339.333 18.8492 336.577 21.7907 338.643 31.2272C340.709 40.6637 344.43 48.7989 347.643 48.3621C356.531 47.1558 359.899 41.7779 363.192 37.1785C367.23 31.5392 360.508 17.1289 360.508 17.1289L353.651 13.504L339.333 18.8492Z",
  fill: "#EAC2AB"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M330.037 15.9882C328.186 10.4201 330.057 4.02614 335.591 0.716226C336.224 0.338884 336.93 -0.00874581 337.694 0.000167774C341.112 0.0417645 339.49 6.60513 345.163 6.18917C348.853 5.91879 351.797 3.58937 355.444 3.26848C360.067 2.8644 363.646 5.0096 366.378 8.11153C367.192 9.03557 372.881 16.3893 369.931 16.8914C379.088 15.3315 370.361 34.7661 368.323 37.3867C366.698 39.4725 363.633 40.447 361.069 39.7488C361.967 37.8383 362.862 35.8863 363.111 33.8064C363.364 31.7266 366.963 22.4327 355.444 19.9399C347.252 18.169 338.908 26.2031 331.739 18.9178C330.985 18.1512 330.42 17.138 330.037 15.9882Z",
  fill: "#57350F"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M363.441 27.02C363.441 27.02 366.849 23.9091 366.244 28.8383C365.638 33.7675 362.657 34.6708 362.657 34.6708L363.441 27.02Z",
  fill: "#EAC2AB"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M380.271 216.403L387.316 232.739L393.742 231.221L385.244 214.561C385.244 214.564 381.6 214.947 380.271 216.403Z",
  fill: "#D4A79A"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M370.851 247.972C371.08 248.311 373.355 248.174 373.694 248.177C377.203 248.221 382.596 248.447 385.614 246.656C388.555 244.909 390.445 241.908 393.043 239.804C394.869 238.324 397.201 237.427 399.361 236.378C401.746 235.22 396.895 225.611 394.001 227.165C391.66 228.424 392.81 231.907 386.839 231.455C381.722 231.066 384.972 237.519 379.02 241.364C373.758 244.763 368.342 244.261 370.851 247.972Z",
  fill: "#F3AA02"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M360.853 156.02C364.45 171.735 371.138 186.169 380.713 199.611C385.382 206.168 387.038 208.108 391.859 214.562C398.735 223.767 380.181 229.406 374.849 230.811C371.357 231.732 366.112 231.795 366.226 229.109C366.26 228.319 366.842 227.564 367.316 226.818C371.636 220.005 367.276 212.803 363.794 206.409C353.354 187.242 351.51 182.696 343.106 162.821C339.907 155.254 338.289 129.568 337.508 121.373C337.03 116.358 341.814 95.6695 351.652 101.478C357.775 105.094 355.036 117.826 354.626 122.966C354.343 126.519 353.738 130.388 354.488 134.007C356.032 141.441 359.154 148.595 360.853 156.02Z",
  fill: "#E0EABA"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M358.263 222.87L353.886 240.456L360.392 242.352L363.726 223.761C363.723 223.764 360.342 222.276 358.263 222.87Z",
  fill: "#EAC2AB"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M327.241 247.384C327.241 247.384 332.109 248.852 341.441 249.464C350.774 250.076 361.19 250.382 363.081 249.158C364.975 247.934 366.193 237.538 363.081 237.538C359.969 237.538 358.761 241.513 353.274 237.966C348.574 234.926 344.819 240.658 336.637 242.185C328.455 243.715 325.141 244.327 327.241 247.384Z",
  fill: "#FDC510"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M343.252 229.754C343.564 229.109 344.385 228.628 345.099 228.126C351.615 223.538 350.024 216.541 348.981 210.426C346.508 195.921 351.74 181.258 350.145 166.791C347.867 146.132 349.502 138.419 345.839 124.615C344.506 119.6 342.67 111.845 351.454 113.313C355.615 114.008 359.723 113.871 363.871 113.229C366.055 112.891 363.828 112.264 366.055 112.891C373.641 115.03 373.043 121.382 372.387 127.571C371.414 136.735 370.805 149.32 370.304 158.626C369.591 171.818 367.105 185.025 368.878 198.116C369.746 204.531 370.755 210.928 371.724 217.331C372.289 221.066 375.825 229.249 373.453 232.63C370.196 237.271 355.686 233.337 350.838 233.233C347.195 233.15 342.188 231.944 343.252 229.754Z",
  fill: "#D6C89C"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M340.799 84.628C342.999 76.7425 340.61 63.4791 346.905 57.6288C347.551 57.0286 348.173 56.271 349.088 56.0957C365.419 52.967 366.32 60.1038 369.718 65.0746C373.123 70.0514 368.494 74.0149 370.159 79.5948C372.05 85.9383 371.67 92.5344 371.804 99.0829C371.888 103.07 371.276 105.025 371.532 109.019C371.71 111.806 371.498 113.862 372.218 116.58C372.696 118.387 376.09 124.692 375.31 126.531C374.691 127.987 371.858 127.437 370.465 127.479C365.079 127.636 363.373 127.612 358.582 125.524C354.206 123.613 337.337 127.918 332.29 127.55C329.784 127.366 335.742 116.646 336.876 112.623C339.564 103.088 338.238 97.9301 339.352 91.1974C339.712 89.0135 340.19 86.8148 340.799 84.628Z",
  fill: "#D7384E"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M349.088 56.0961C349.088 56.0961 344.768 59.5456 333.942 55.1958L330.362 65.075C330.362 65.075 340.822 69.4962 345.805 66.1536C350.097 63.2775 348.974 56.2951 349.088 56.0961Z",
  fill: "#D7384E"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M369.442 98.0226C366.923 103.867 335.147 109.245 319.671 108.065C315.879 107.777 311.886 107.349 309.342 110.071C311.152 110.846 312.511 110.353 314.466 110.671C312.145 112.498 309.823 114.329 307.502 116.156C306.785 116.72 305.991 117.591 306.412 118.384C306.721 118.973 307.529 119.109 308.212 119.1C312.717 119.038 316.495 115.918 320.778 114.575C326.056 112.92 330.262 113.428 335.564 112.62C371.471 107.147 379.448 106.199 377.164 86.6103C375.428 71.7187 372.056 69.3952 367.182 64.6977C366.408 63.9519 365.015 63.227 364.271 63.9935C363.901 64.3768 363.949 64.9473 364.049 65.4435C364.621 68.2364 366.213 70.7649 367.494 73.3677C370.637 79.7557 371.616 92.9865 369.442 98.0226Z",
  fill: "#EAC2AB"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M364.262 76.8352C364.262 76.8352 354.481 53.1607 362.536 56.5211C370.529 59.8578 378.287 74.9158 378.287 74.9158L364.971 79.9163L364.262 76.8352Z",
  fill: "#F44E4E"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6119 169.06C14.5404 175.746 23.116 180.366 32.6707 179.332L264.142 154.237C273.697 153.2 280.752 146.883 279.823 140.201L278.081 127.672L11.8691 156.528L13.6119 169.06Z",
  fill: "#4493DA"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M266.336 43.1836C265.192 34.9445 256.438 29.0526 246.883 30.0896L15.4118 55.1843C5.85715 56.2212 -1.01951 63.8067 0.124361 72.0458L5.00598 107.168L271.218 78.3091L266.336 43.1836Z",
  fill: "#4493DA"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  width: 267.757,
  height: 49.8361,
  transform: "matrix(0.994178 -0.10775 0.137635 0.990483 4.99805 107.161)",
  fill: "#1B5A93"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M34.7533 100.779C42.8079 100.779 49.3376 95.0128 49.3376 87.8993C49.3376 80.7858 42.8079 75.0192 34.7533 75.0192C26.6986 75.0192 20.1689 80.7858 20.1689 87.8993C20.1689 95.0128 26.6986 100.779 34.7533 100.779Z",
  fill: "#1B5A93"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M245.564 111.892L208.042 115.959C203.036 116.503 198.437 113.33 197.822 108.909L195.366 91.2477C194.75 86.8266 198.343 82.765 203.349 82.2212L240.871 78.1537C245.877 77.6099 250.476 80.7832 251.092 85.2043L253.548 102.865C254.164 107.286 250.571 111.348 245.564 111.892Z",
  fill: "#978CFF"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M30.0889 124.573C30.0889 133.074 37.9647 140.029 47.59 140.029H280.801C290.426 140.029 298.302 133.074 298.302 124.573V108.639H30.0889V124.573Z",
  fill: "#A9CCEB"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M298.297 21.4613C298.297 12.9607 290.421 6.00513 280.796 6.00513H47.5852C37.9598 6.00513 30.084 12.9607 30.084 21.4613V57.7039H298.294V21.4613H298.297Z",
  fill: "#A9CCEB"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  x: 30.0889,
  y: 57.7043,
  width: 268.21,
  height: 50.9352,
  fill: "#E3E5FC"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M66.0589 44.9808C74.1136 44.9808 80.6432 39.2142 80.6432 32.1007C80.6432 24.9872 74.1136 19.2206 66.0589 19.2206C58.0042 19.2206 51.4746 24.9872 51.4746 32.1007C51.4746 39.2142 58.0042 44.9808 66.0589 44.9808Z",
  fill: "#50A7F4"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M271.989 78.6001H234.184C229.141 78.6001 225.013 74.9544 225.013 70.5006V52.7091C225.013 48.2553 229.141 44.6096 234.184 44.6096H271.989C277.032 44.6096 281.16 48.2553 281.16 52.7091V70.5006C281.16 74.9544 277.035 78.6001 271.989 78.6001Z",
  fill: "#50A7F4"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M93.3395 100.052H54.014C51.4134 100.052 49.2871 98.174 49.2871 95.8772V94.5669C49.2871 92.2702 51.4134 90.3924 54.014 90.3924H93.3395C95.9401 90.3924 98.0663 92.2702 98.0663 94.5669V95.8772C98.0663 98.174 95.9401 100.052 93.3395 100.052Z",
  fill: "white"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M154.628 100.052H115.302C112.701 100.052 110.575 98.174 110.575 95.8772V94.5669C110.575 92.2702 112.701 90.3924 115.302 90.3924H154.628C157.228 90.3924 159.354 92.2702 159.354 94.5669V95.8772C159.354 98.174 157.225 100.052 154.628 100.052Z",
  fill: "white"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M215.912 100.052H176.59C173.99 100.052 171.863 98.174 171.863 95.8772V94.5669C171.863 92.2702 173.99 90.3924 176.59 90.3924H215.916C218.516 90.3924 220.642 92.2702 220.642 94.5669V95.8772C220.639 98.174 218.513 100.052 215.912 100.052Z",
  fill: "white"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M276.432 100.052H237.107C234.506 100.052 232.38 98.174 232.38 95.8772V94.5669C232.38 92.2702 234.506 90.3924 237.107 90.3924H276.432C279.033 90.3924 281.159 92.2702 281.159 94.5669V95.8772C281.159 98.174 279.033 100.052 276.432 100.052Z",
  fill: "white"
});

var SvgGuyWithCards = function SvgGuyWithCards(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 250,
    viewBox: "0 0 400 250",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGuyWithCards, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/guy_with_cards.764bbede.svg";
export { ForwardRef as ReactComponent };